// extracted by mini-css-extract-plugin
module.exports = {"activeQuestion":"ActiveQuestion_activeQuestion__16I3J"};